export default __webpack_public_path__ + "static/media/icon-self-care.a161aff5.svg";